// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\UserNotificationSettingResponse

import { NotificationSound } from './enums.gen';
import { hydrateNotificationSettingCapabilities, type NotificationSettingCapabilities, type NotificationSettingCapabilitiesApiResponse } from './notificationSettingCapabilities.gen';

export type UserNotificationSettingApiResponse = {
	event: string;
	notifyApp: boolean;
	notifyPushDesktop: boolean;
	notifyPushMobile: boolean;
	notifyEmail: boolean;
	sound: NotificationSound;
	capabilities: NotificationSettingCapabilitiesApiResponse;
};

export type UserNotificationSetting = {
	event: string;
	notifyApp: boolean;
	notifyPushDesktop: boolean;
	notifyPushMobile: boolean;
	notifyEmail: boolean;
	sound: NotificationSound;
	capabilities: NotificationSettingCapabilities;
};

export function hydrateUserNotificationSetting(data: UserNotificationSettingApiResponse): UserNotificationSetting {
	return {
		...data,
		capabilities: hydrateNotificationSettingCapabilities(data.capabilities),
	};
}